
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voyager-pet-owner-terms-conditions",
      function () {
        return require("private-next-pages/voyager-pet-owner-terms-conditions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voyager-pet-owner-terms-conditions"])
      });
    }
  